import { Observable } from '@apollo/client'
import { logError } from '@local/do-secundo-error'
// useful for parsing response errors
// https://artsy.github.io/blog/2018/10/19/where-art-thou-my-error/

export const dataByTypename = (data) =>
  data && data.__typename ? { [data.__typename]: data } : {}

/**
 * @param promise
 * @returns {Observable<unknown> | Observable}
 */
export const promiseToObservable = (promise) =>
  new Observable(async (subscriber) => {
    try {
      const value = await promise
      if (value && !subscriber.closed) {
        subscriber.next(value)
        subscriber.complete()
      }
    } catch (err) {
      logError(err)
      subscriber.error(err)
    }
  })
